export const GARCONS = "GARCONS";
export const FILLES = "FILLES";
export const JUNGLE = "JUNGLE";
export const DESERT = "DESERT";